import { useState } from 'react';
import VideoCard from '@/components/base/VideoCard';
import { videos, getVideosByCategory } from '@/mocks/videos';

const tabs = [
  { key: 'all', label: '最新上架' },
  { key: 'dianying', label: '电影' },
  { key: 'dianshiju', label: '电视剧' },
  { key: 'zongyi', label: '综艺' },
  { key: 'dongman', label: '动漫' },
];

export default function RecommendedSection() {
  const [activeTab, setActiveTab] = useState('all');

  const displayVideos = activeTab === 'all'
    ? videos.filter((v) => v.isNew).slice(0, 8)
    : getVideosByCategory(activeTab).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              精选内容
            </h2>
          </div>

          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/70">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-accent-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}